/** Normalises a user-entered mobile number to "+<country><number>" (matches the backend rule). Null if implausible. */
export function normalizeMobile(raw: string, defaultCountryCode = '91'): string | null {
  let digits = (raw || '').replace(/\D/g, '');
  if (digits.length === 10) digits = defaultCountryCode + digits;
  if (digits.length < 11 || digits.length > 15) return null;
  return `+${digits}`;
}
